export const UrlFormatter = {
  
  ReplaceBaseUrlWithDots: (html, baseUrl) => {
    const regex = new RegExp(`src=["']${baseUrl}`, 'gi');
    return html.replace(regex, 'src="..');
  }
};